import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name:'Index',//大赛介绍
		component: () => import('@/views/index/index.vue'),
	},
	{
		path: '/contest',
		name:'',//大赛声明
		component: () => import('@/views/contestStatement/index.vue'),
	},
	{
		path: '/upload',
		name:'',//上传
		component: () => import('@/views/uploadWorks/index.vue'),
	},
]

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior(to, from, savedPosition) {
	    // 期望滚动到哪个位置
	    return {
	      x: 0,
	      y: 0
	    }
	  },
})
router.beforeEach((to, from, next) => {
	
  // 判断用户访问的路由是否存在
  if (to.matched.length === 0) {
    // 如果路由不存在，则跳转到指定页面
    // next('/null');
    next('/');
  } else {
	// 让页面回到顶部
	// document.documentElement.scrollTop = 0
    // 路由存在，则继续访问该路由
    next();
  }
});
export default router
